export const unknownUserId = "6e2797aa-1ea3-434e-b17a-865c52b641db";
export const unknownTeamId = "f5de53d1-4548-41f5-90c0-79c05f1def04";
export const unknownOrganisationId = "1767714a-9382-4aa0-9426-738747c92fc3";
export const unknownFormId = "c157b632-94ce-47b4-8398-2a71643ef949";
export const unknownSiteId = "5f3d0848-5150-48cf-8241-1cb8515c7b9c";
export const unknownQuestionId = "03eea429-e8e4-4303-be11-2a8d08df1ece";
export const unknownOutcomeId = "5f3d0848-5150-48cf-8241-1cb8515c7b9c";
